import React from 'react';

import { api } from '../../../../../core/api';
import CompanyTabContent from '../shared/CompanyTabContent';
import { useCompanyTabLoader } from '../shared/useCompanyTabLoader';
import OwnershipBranchesList from './OwnershipBranchesList';

const CompanyBranches: React.FC = () => {
  const { data, isLoading } = useCompanyTabLoader(api.company.getBranchesData);
  const slicedData = {
    currentDetail: data?.branchDetails?.currentDetail?.slice(0, 500),
    historicDetail: data?.branchDetails?.historicDetail?.slice(0, 500),
  };
  return (
    <CompanyTabContent isLoading={isLoading}>
      <OwnershipBranchesList data={slicedData} />
    </CompanyTabContent>
  );
};

export default CompanyBranches;
